<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar
        title="时光留影"
        fixed
        :z-index="99"
        left-arrow
        @click-left="onClickLeft"
        :border="false"
     />
    <div class="navBarSpace"></div>
    <!-- header end -->
   <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :offset="offset"
          :immediate-check="ischeck"
          @load="loadMore"
        >
        <div is-link center v-for="item in dataList" :key="item.MemorialHallID" >
            <router-link class="album-list" :to="{path:'/Photos', query:{id : item.MemorialHallSerialNumber}}" >
              <div class="hd">
                <van-image
                  width="100%"
                  height="100%"
                  fit="cover"
                  v-bind:src="item.UseFirstImgInfo"
                />
              </div>
              <div class="bd">
                <h2 class="title">{{item.Title}}</h2>
                <div class="from">来自：<span class="hlight">{{item.MemorialHallTitle}}</span></div>
                <div class="btm">
                  <div class="total">共 <span class="corange">{{item.ImgCount}}</span> 张</div>
                  <p class="date">{{$moment(item.RecommendDateTime).format('YYYY-MM-DD')}}</p>
                </div>
              </div>
              <div class="arrowBtn"><i class="fa fa-chevron-right"></i></div>
            </router-link>
        </div>


      </van-list>
   </van-pull-refresh>
    <!-- <div>
      <router-link class="album-list" to="/Photos" v-for="item in 3" :key="item.id">
        <div class="hd">
          <van-image
            width="100%"
            height="100%"
            fit="cover"
            src="https://img.yzcdn.cn/vant/cat.jpeg"
          />
        </div>
        <div class="bd">
          <h2 class="title">幸福家园</h2>
          <div class="from">来自：<span class="hlight">杨常富</span></div>
          <div class="btm">
            <div class="total">共 <span class="corange">9</span> 张</div>
            <p class="date">2020-02-19</p>
          </div>
        </div>
        <div class="arrowBtn"><i class="fa fa-chevron-right"></i></div>
      </router-link>
    </div> -->
  </div>
</template>

<script>
	export default {
	  data() {
	    return {
        refreshing: false,
        loading: true,
        finished: false,
        offset: 100,
        ischeck: false,
        isLogin: false,
        options: null,
        dataList : [],
	    };
	  },
	  components: {
    },
    created(){
      this.init();
    },
    activated(){
      // this.init();
    },
    
    mounted() {
      document.querySelector('body').removeAttribute('style')
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      init(){
        var that = this;
        that.options = {
          type: "GetImageManageImageList",
          pageIndex: 1
        };
        that.getDataList();
      },
      onRefresh() {
        this.finished = false;
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        Object.assign(this.options, {
          pageIndex: 1
        });
        this.getDataList();
      },
      loadMore() {
        Object.assign(this.options, {
          pageIndex: this.options.pageIndex + 1
        });
        this.loading = true;
        this.getDataList();
      },
      getDataList(){
        var _this = this;
        this.$store
          .dispatch(_this.options)
          .then(result => {
            _this.loading = false;
            if (_this.refreshing) {
              _this.refreshing = false;
            }

            var dataList = result.ImageManageApiModelList;

            if(dataList.length == 0){
              _this.finished = true;
              return;
            }

            if(_this.options.pageIndex > 1){
              for (let i = 0; i < dataList.length; i++) {
                _this.dataList.push(
                  dataList[i]
                );
              }
            }else{
              _this.dataList = dataList;
            }

            if (dataList.length < 10) {
                _this.finished = true;
            }
        },
        error => {}
        );
      }
    }
	};
</script>

<style >
.album-list{
  display: flex;
  align-items: center;
  position: relative;
  background-color: #f2f2f2;
  overflow: hidden;
  margin: 12px;
}
.album-list>.hd{
  width: 100px;
  height: 126px;
}
.album-list>.bd{
  flex: 1;
  overflow: hidden;
  position: relative;
  padding: 10px;
}
.album-list>.bd>.title{
  font-weight: normal;
  font-size: 17px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #666
}
.album-list>.bd>.btm{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 6px;
}
.album-list>.bd>.from{
  margin-top: 6px;
  font-size: 12px;
  color: #666;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.album-list>.bd>.from>.hlight{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: lightskyblue !important
}
.album-list>.bd>.btm>.total{
  color: #666;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: 1;
}
.album-list>.bd>.btm>.date{
  font-size: 12px;
  color: #aaa;
}
.album-list .arrowBtn{
  position: absolute;
  right: 12px;
  top: 0;
  bottom: 0;
  font-size: 32px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
